module.exports = __webpack_public_path__ + "static/img/BiazfanxmamNRoxxVxka.d19d6cb9.png";